var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-modal',{attrs:{"footer":null,"title":"Proceso de Captura de Firma","width":500},on:{"cancel":function($event){return _vm.$emit('cancel')}},model:{value:(_vm.isVisible),callback:function ($$v) {_vm.isVisible=$$v},expression:"isVisible"}},[_c('div',{ref:"wacom-signature-pad",staticStyle:{"height":"320px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }